module.exports = __webpack_public_path__ + "img/12.ed21aa01.png";